import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import http from '../http';
import { useTranslation } from '../t';
import { inject, observer } from 'mobx-react';
import ReactMarkdown from 'react-markdown';
import axios from 'axios';
import { passwordRegex, phoneRegex } from '../const';
import logo from '../assets/logo.png';
import ICP from '../components/ICP';
import CaptchaInput from '../components/CaptchaInput';
import C from '../colors';

const inputStyle = (error) => ({
  width: '100%', boxSizing: 'border-box',
  padding: '10px 14px', borderRadius: 9, outline: 'none',
  border: `1.5px solid ${error ? '#e88c7c' : C.hair}`,
  fontFamily: C.sans, fontSize: 14, color: C.ink, background: '#fff',
  transition: 'border-color .2s',
});

function Field({ label, error, children }) {
  return (
    <div style={{ marginBottom: 16 }}>
      <div style={{ fontSize: 12, fontWeight: 600, color: error ? '#c2412e' : C.ink3, marginBottom: 5 }}>{label}</div>
      {children}
      {error && <div style={{ fontSize: 11.5, color: '#c2412e', marginTop: 4 }}>{error}</div>}
    </div>
  );
}

function UserAgreementDialog({ open, onClose }) {
  const [text, setText] = useState('');
  useEffect(() => { if (open) axios.get('/agreement.md').then(r => setText(r.data)); }, [open]);
  if (!open) return null;
  return (
    <div onClick={onClose} style={{ position: 'fixed', inset: 0, zIndex: 1200, background: 'rgba(26,20,23,.45)', backdropFilter: 'blur(6px)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24 }}>
      <div onClick={e => e.stopPropagation()} style={{ background: C.paper, borderRadius: 14, border: `1px solid ${C.hair}`, width: '100%', maxWidth: 600, maxHeight: '80vh', overflow: 'auto', padding: 28 }}>
        <h2 style={{ margin: '0 0 16px', fontFamily: C.serif, fontSize: 22, fontWeight: 400 }}>用户协议</h2>
        {text ? <ReactMarkdown>{text}</ReactMarkdown> : <p style={{ color: C.ink3 }}>加载中…</p>}
        <button onClick={onClose} style={{ marginTop: 16, padding: '8px 20px', borderRadius: 8, border: `1px solid ${C.hair2}`, background: '#fff', cursor: 'pointer' }}>关闭</button>
      </div>
    </div>
  );
}

const ForgetPassworPage = inject('snackbarStore')(observer(({ snackbarStore }) => {
  const [phone, setPhone] = useState('');
  const [phoneError, setPhoneError] = useState('');
  const [password, setPassword] = useState('');
  const [passwordError, setPasswordError] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [confirmPasswordError, setConfirmPasswordError] = useState('');
  const [captcha, setCaptcha] = useState('');
  const [captchaError, setCaptchaError] = useState('');
  const [captchaID, setCaptchaID] = useState('');
  const [code, setCode] = useState('');
  const [codeError, setCodeError] = useState('');
  const [countdown, setCountdown] = useState(null);
  const [openAgreement, setOpenAgreement] = useState(false);
  const navigate = useNavigate();
  const { t } = useTranslation();

  const vPhone = v => !v ? '手机号不能为空' : !phoneRegex.test(v) ? '手机号应为11位数字' : '';
  const vPassword = v => !v ? '密码不能为空' : !passwordRegex.test(v) ? '密码至少6位，可含字母数字及@$!%*#?&' : '';
  const vConfirm = v => !v ? '密码不能为空' : v !== password ? '两次密码不一致' : '';
  const vCaptcha = v => !v ? '验证码不能为空' : v.length !== 4 ? '验证码格式错误' : '';
  const vCode = v => !v ? '手机验证码不能为空' : v.length !== 4 ? '手机验证码格式错误' : '';

  const handleChange = e => {
    const { name, value } = e.target;
    if (name === 'phone') { setPhone(value); setPhoneError(vPhone(value)); }
    else if (name === 'password') { setPassword(value); setPasswordError(vPassword(value)); }
    else if (name === 'confirmPassword') { setConfirmPassword(value); setConfirmPasswordError(vConfirm(value)); }
    else if (name === 'code') { setCode(value); setCodeError(vCode(value)); }
    else if (name === 'captcha') { setCaptcha(value); setCaptchaError(vCaptcha(value)); }
  };

  const handleSend = e => {
    e.preventDefault();
    const pe = vPhone(phone), ce = vCaptcha(captcha);
    setPhoneError(pe); setCaptchaError(ce);
    if (pe || ce) return;
    http.post('/sendCodeForReset', { phone, captchaID }).then(() => {
      snackbarStore.showSnackbar('发送成功');
      setCountdown(60);
      const timer = setInterval(() => setCountdown(p => { if (p <= 1) { clearInterval(timer); return null; } return p - 1; }), 1000);
    }).catch(err => {
      const message = err?.response?.data?.error || '验证码发送失败，请稍后重试';
      setCaptchaError(message === 'Captcha error' ? '图形验证码错误或已过期' : message);
      snackbarStore.showSnackbar(message, 'error');
    });
  };

  const handleSubmit = e => {
    e.preventDefault();
    const pe = vPhone(phone), ce = vCaptcha(captcha), pw = vPassword(password), cpw = vConfirm(confirmPassword), co = vCode(code);
    setPhoneError(pe); setCaptchaError(ce); setPasswordError(pw); setConfirmPasswordError(cpw); setCodeError(co);
    if (pe || ce || pw || cpw || co) return;
    http.post('/forgetPassword', { phone, password, code }).then(() => {
      snackbarStore.showSnackbar('重置密码成功');
      navigate('/login');
    }).catch(err => {
      const message = err?.response?.data?.error || '重置密码失败，请稍后重试';
      const visibleMessage = message === 'Code error or expired' ? '手机验证码错误或已过期' : message;
      setCodeError(visibleMessage);
      snackbarStore.showSnackbar(visibleMessage, 'error');
    });
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: '100vh', background: C.paper, padding: 24 }}>
      <div style={{ background: '#fff', borderRadius: 16, border: `1px solid ${C.hair}`, padding: '36px 40px', width: '100%', maxWidth: 420, boxShadow: '0 12px 32px -12px rgba(0,0,0,.12)' }}>
        <div style={{ textAlign: 'center', marginBottom: 24 }}>
          <img src={logo} alt="图派" style={{ width: 96, height: 96, objectFit: 'contain', marginBottom: 8 }}/>
          <h2 style={{ margin: 0, fontFamily: C.serif, fontSize: 28, fontWeight: 400, color: C.ink }}>忘记密码</h2>
        </div>
        <form onSubmit={handleSubmit}>
          <Field label="手机号" error={phoneError}>
            <input name="phone" value={phone} onChange={handleChange} style={inputStyle(!!phoneError)}/>
          </Field>
          <Field label="验证码图" error={captchaError}>
            <CaptchaInput placeholder="验证码" error={!!captchaError} helperText={captchaError} onChange={handleChange} captcha={captcha} setCaptcha={setCaptcha} captchaID={captchaID} setCaptchaID={setCaptchaID}/>
          </Field>
          <Field label="手机验证码" error={codeError}>
            <div style={{ display: 'flex', gap: 8 }}>
              <input data-testid="reset-sms-code" name="code" value={code} onChange={handleChange} style={{ ...inputStyle(!!codeError), flex: 1 }}/>
              <button type="button" onClick={handleSend} disabled={!!countdown} style={{ padding: '0 14px', borderRadius: 9, border: 'none', background: countdown ? C.hair2 : C.brand, color: '#fff', fontFamily: C.sans, fontSize: 13, cursor: countdown ? 'not-allowed' : 'pointer', whiteSpace: 'nowrap' }}>
                {countdown ? `${countdown} 秒` : '发送'}
              </button>
            </div>
          </Field>
          <Field label="新密码" error={passwordError}>
            <input name="password" type="password" value={password} onChange={handleChange} style={inputStyle(!!passwordError)}/>
          </Field>
          <Field label="确认密码" error={confirmPasswordError}>
            <input name="confirmPassword" type="password" value={confirmPassword} onChange={handleChange} style={inputStyle(!!confirmPasswordError)}/>
          </Field>
          <button data-testid="reset-password-submit" type="submit" style={{ width: '100%', padding: '11px 0', borderRadius: 10, border: 'none', background: C.brand, color: '#fff', fontFamily: C.sans, fontSize: 14, fontWeight: 600, cursor: 'pointer', marginTop: 8, boxShadow: `0 1px 0 ${C.brand2}` }}>
            重置密码
          </button>
        </form>
      </div>
      <div style={{ marginTop: 32 }}><ICP/></div>
      <UserAgreementDialog open={openAgreement} onClose={() => setOpenAgreement(false)}/>
    </div>
  );
}));
export default ForgetPassworPage;
